import {
  // UserOutlined,
  ReadOutlined,
  MessageFilled,
  WhatsAppOutlined,
  StockOutlined,
  ProductFilled,
  MenuOutlined,
  ContainerOutlined,
  ProductOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Divider } from "antd";
import "./index.css";
import { RiStockFill } from "react-icons/ri";
import { IoPricetags } from "react-icons/io5";

const itemSelectTabs = [
  {
    label: "Item Details",
    key: "1",
    icon: <ProductFilled className="text-[16px]" />,
  },
  {
    label: "Stock Details",
    key: "2",
    icon: <ProductOutlined className="text-[16px]" />,
  },
  {
    label: "Party Wise Report",
    key: "3",
    icon: <ReadOutlined className="text-[16px]" />,
  },
];
const partySelectItems = [
  {
    label: <a href="/parties/data">Sales Invoice</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/payment-in">Payment In</a>,
    key: "2",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Quotation</a>,
    key: "3",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Proforma Invoice</a>,
    key: "4",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Sales Return</a>,
    key: "5",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Delivery Challan</a>,
    key: "6",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Purchase Order</a>,
    key: "7",
  },
];
const transactionsList = [
  {
    label: "Sales Invoice",
    key: "1",
  },

  {
    label: "Payment In",
    key: "2",
  },

  {
    label: "Quotation",
    key: "3",
  },

  {
    label: "Proforma Invoice",
    key: "4",
  },
  {
    label: "Sales Return",
    key: "5",
  },

  {
    label: "Delivery Challan",
    key: "6",
  },

  {
    label: "Purchase Order",
    key: "7",
  },
];
const itemHeaderData = [
  {
    key: "date",
    title: "Date",
    dataIndex: "date",
    sorter: (a, b) => a.date.length - b.date.length,
  },
  {
    key: "transactionType",
    title: "Transaction Type",
    dataIndex: "transactionType",
  },
  {
    key: "quantity",
    title: "Quantity",
    dataIndex: "quantity",
  },
  {
    key: "invoiceNumber",
    title: "Invoice Number",
    dataIndex: "invoiceNumber",
  },

  {
    key: "closingStock",
    title: "Closing Stock",
    dataIndex: "closingStock",
  },
];
const itemSelectHeaders = [
  {
    label: "Eggs",
    key: "1",
    amount: "₹ 120",
    mode: "credit",
    color: "blue",
  },
  {
    label: "Fish",
    key: "2",
    amount: "₹ 600",
    mode: "debit",
    color: "green",
  },
  {
    label: "Maggie",
    key: "3",
    amount: "₹ 250",
    mode: "credit",
    color: "red",
  },
];

const itemHeadersColumns = [
  {
    key: "transactionType",
    title: "Type",
    dataIndex: "transactionType",
  },
  {
    key: "vendorName",
    title: "Name",
    dataIndex: "vendorName",
  },
  {
    key: "salesQuantity",
    title: "Sales Quantity",
    dataIndex: "salesQuantity",
  },
  {
    key: "salesAmount",
    title: "Sales Amount",
    dataIndex: "salesAmount",
  },
  {
    key: "quantity",
    title: "Purchase Quantity",
    dataIndex: "quantity",
  },
  {
    key: "amount",
    title: "Purchase Amount",
    dataIndex: "amount",
  },
];

const itemTableList = [
  {
    partyName: "Salmaan",
    salesQuantity: "3.0 PCS",
    salesAmount: "₹ 1,600",
    purchaseQuantity: "3.0 PCS",
    purchaseAmount: "₹ 1,350",
  },
  {
    partyName: "Karthick",
    salesQuantity: "2.0 PCS",
    salesAmount: "₹ 2,800",
    purchaseQuantity: "1.0 PCS",
    purchaseAmount: "₹ 1,000",
  },
  {
    partyName: "Jaffer",
    salesQuantity: "0.0 PCS",
    salesAmount: "-",
    purchaseQuantity: "100.0 PCS",
    purchaseAmount: "₹ 1,600",
  },
];

const ledgerStatementDetails = [
  {
    date: "",
    voucher: "Opening Balance",
    sNo: "-",
    key: "1",
    credit: "-",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "0.0",
  },
  {
    date: "06 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "1	",
    key: "2",
    credit: "75.0	",
    debit: "375.0",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "300",
  },
  {
    date: "07 Aug 2024",
    voucher: "Purchase Record",
    sNo: "4",
    key: "3",
    credit: "900.0",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "08 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "6",
    key: "4",
    credit: "-",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "12 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "7",
    key: "5",
    credit: "-",
    debit: "125.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-475",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment out",
    sNo: "2",
    key: "6",
    credit: "-",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "425",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment In",
    sNo: "4",
    key: "",
    credit: "825.0",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-400",
  },
  {
    date: "",
    voucher: "Closing Balance",
    sNo: "-",
    key: "1",
    credit: "350",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "-350",
  },
];
const ledgerStatementList = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[130px] h-[60px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex border-x-0 border-t-0 text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <MessageFilled className="mr-1" />
          SMS
        </a>
      </p>
      <Divider className="w-[185%] mt-[4px] ml-[-24px]" />
      <p className="flex mt-[-20px] text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <WhatsAppOutlined className="mr-1" />
          Whatsapp
        </a>
      </p>
    </div>
  </div>
);

const HeaderData = [
  {
    key: "itemName",
    title: <h1 className="header-items-table font-semibold">Item Name</h1>,
    sort: true,
    dataIndex: "itemName",
  },
  {
    key: "itemCode",
    title: <h1 className="header-items-table font-semibold">Item Code</h1>,
    sort: false,
    dataIndex: "itemCode",
  },
  {
    key: "stockQTY",
    title: <h1 className="header-items-table font-semibold">Stock QTY</h1>,
    sort: true,
    dataIndex: "stockQTY",
  },
  {
    key: "salesPrice",
    title: <h1 className="header-items-table font-semibold">Sales Price</h1>,
    sort: false,
    dataIndex: "salesPrice",
  },
  {
    key: "purchasePrice",
    title: <h1 className="header-items-table font-semibold">Purchase Price</h1>,
    sort: false,
    dataIndex: "purchasePrice",
  },
  {
    title: <h1 className="header-items-table font-semibold">Action</h1>,
    sort: false,
    dataIndex: "action",
  },
];
const HeaderStockData = [
  {
    key: "itemName",
    title: "Item Name",
    sort: true,
    dataIndex: "itemName",
  },
  {
    key: "itemCode",
    title: "Item Code",
    sort: false,
    dataIndex: "itemCode",
  },
  {
    key: "purchasePrice",
    title: "Purchase Price",
    sort: false,
    dataIndex: "purchasePrice",
  },
  {
    key: "salesPrice",
    title: "Sales Price",
    sort: false,
    dataIndex: "salesPrice",
  },
  {
    key: "stockQTY",
    title: "Stock QTY",
    sort: true,
    dataIndex: "stockQTY",
  },
  {
    key: "stockValue",
    title: "Stock Value",
    sort: true,
    dataIndex: "stockValue",
  },
];

const gstOptions = [
  {
    label: "None",
    value: "None",
  },
  {
    label: "Excempted",
    value: "Excempted",
  },
  {
    label: "GST @ 2%",
    value: "GST @ 2%",
  },
  {
    label: "GST @ 5%",
    value: "GST @ 5%",
  },
  {
    label: "GST @ 8%",
    value: "GST @ 8%",
  },
  {
    label: "GST @ 12%",
    value: "GST @ 12%",
  },
  {
    label: "GST @ 15%",
    value: "GST @ 15%",
  },
  {
    label: "GST @ 18%",
    value: "GST @ 18%",
  },
  {
    label: "GST @ 21%",
    value: "GST @ 21%",
  },
  {
    label: "GST @ 25%",
    value: "GST @ 25%",
  },
  {
    label: "GST @ 28%",
    value: "GST @ 28%",
  },
];

const TableData = [
  {
    name: "1",
    category: "Musk",
    mobile: "777",
    partyType: "partyType",
    balance: "Balance",
  },
  {
    name: "2",
    category: "Andrew",
    mobile: "777",
    partyType: "Data",
    balance: "Balance",
  },
];
const itemHeaders = [
  {
    label: "Stock Value",
    key: "1",
    icon: <StockOutlined />,

    amount: "₹ 0",
    color: "blue",
  },
  {
    label: "Low Stock",
    key: "2",
    icon: <ProductFilled />,
    items: "0",
    color: "orange",
  },
];

const balaceCollectOptions = [
  {
    label: "To Collect",
    value: "toCollect",
  },
  {
    label: "To Pay",
    value: "toPay",
  },
];
const partyFaqList = [
  {
    key: "1",
    label: "I have Hundreds of items. How do I add them at once?",
    children: (
      <p className="text-[12px]">
        Not to worry, you don't need to create the items one by one. myBillBook
        allows you to import your items in bulk. <br />
        - Incase you're a user of Vyapar, Tally, Marg etc, please upload your
        file through our mobile app. In the mobile app, you can find this option
        in Items tab, by clicking the top right settings button. Contact our
        support team for any help.
        <br /> - To import items through Excel click here.
      </p>
    ),
  },
  {
    key: "2",
    label: "What are Item Categories? How to use them?",
    children: (
      <p className="text-[12px]">
        Item Categories allow for easier management of items by grouping similar
        items together. Your item categories will also be displayed in your
        Online Store to help your customers find what they need easily.
      </p>
    ),
  },
  {
    key: "3",
    label: "How to add more item information like Expiry Date, Batch No, Size?",
    children: (
      <p className="text-[12px]">
        myBillBook provides default item fields which are applicable for every
        industry. Incase you require to add custom item fields like Batch, Size,
        Color etc, you can do that by going to Item Settings and clicking on +
        Add Custom Field.
      </p>
    ),
  },
  {
    key: "4",
    label: "How is Stock Value calculated?",
    children: (
      <p className="text-[12px]">
        By default, Stock Value is calculated based on Purchase Price entered
        for your item multiplied by the current stock of that item. You can
        change it to calculate based on Sales Price instead by going to Item
        Settings.
      </p>
    ),
  },
  {
    key: "5",
    label: "How to add MRP or Wholesale Price?",
    children: (
      <p className="text-[12px]">
        MRP and Wholesale Price(along with minimum wholesale quantity) can be
        added to your items by enabling these options from Item Settings.
      </p>
    ),
  },
  {
    key: "6",
    label: "How to create GST/Non-GST party?",
    children: (
      <p className="text-[12px]">
        On myBillBook you can track the full history of your items stock; right
        from opening stock to every sale, purchase and adjustment. Click on an
        item and then Stock Details to see it. Alternatively, you can select
        "Stock Details Report" in the Report section.
      </p>
    ),
  },
];
const itemList = [
  {
    value: "Stock Details",
    label: "Stock Details",
    type: "product",
    icon: <RiStockFill />,
  },
  {
    value: "Pricing Details",
    label: "Pricing Details",
    type: "product",
    icon: <IoPricetags />,
  },
  {
    value: "Custom Fields",
    label: "Custom Fields",
    type: "product",
    icon: <MenuOutlined />,
  },
  {
    value: "Other Details",
    label: "Other Details",
    type: "service",
    icon: <ContainerOutlined />,
  },
  {
    value: "Custom Fields",
    label: "Custom Fields",
    type: "service",
    icon: <MenuOutlined />,
  },
];
const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];
// const bulkActions = (

// );
export {
  itemHeaders,
  balaceCollectOptions,
  TableData,
  partyTypeOptions,
  gstOptions,
  itemSelectTabs,
  itemSelectHeaders,
  partySelectItems,
  transactionsList,
  ledgerStatementDetails,
  itemTableList,
  itemHeadersColumns,
  ledgerStatementList,
  HeaderData,
  itemHeaderData,
  HeaderStockData,
  partyFaqList,
  itemList,
};
